import type {
  CompanyDiscoveryAiOutput,
  TalentDiscoveryAiFilterSearchResponseV2,
} from '@revelio/data-access';

/**
 * How to resolve and apply global-assistant "route filter" pre-fetch for a
 * navigation target. Inline CustomDash AI search already branches screener vs TD;
 * the global assistant must mirror that for the queued pre-resolve path.
 */
export type GlobalAssistantRouteFilterKind = 'tdV2' | 'screener';

/** Result of pre-resolving filters before navigation; discriminated for apply. */
export type GlobalAssistantResolvedRouteFilters =
  | { filterKind: 'tdV2'; response: TalentDiscoveryAiFilterSearchResponseV2 }
  | { filterKind: 'screener'; response: CompanyDiscoveryAiOutput };

/**
 * Standalone Talent Discovery product (`/talent-discovery`).
 */
export function isTalentDiscoveryPublicPath(navigatePath: string): boolean {
  const n = navigatePath.split('/').filter(Boolean);
  return n.length === 1 && n[0] === 'talent-discovery';
}

/**
 * Company / geography / role Discovery (screener) — dedicated AI endpoint+transform.
 */
export function isScreenerV2DashboardPath(navigatePath: string): boolean {
  const n = navigatePath.split('/').filter(Boolean);
  return n.length === 2 && n[1] === 'screener';
}

export function getGlobalAssistantRouteFilterKind(
  navigatePath: string
): GlobalAssistantRouteFilterKind {
  if (isScreenerV2DashboardPath(navigatePath)) {
    return 'screener';
  }
  return 'tdV2';
}
